import { jbColors } from '../jbColors';

export const MuiAutocomplete = {
  styleOverrides: {
    inputRoot: {
      '&&[class*="MuiFilledInput-root"]': {
        backgroundColor: jbColors.support.greenSmoke[10],
        borderRadius: 0,
        padding: '4px',
      },
    },
  },
};
